import React from 'react';
import styled from 'styled-components';
import {
  RenderHtml,
  ReportCustomQuestionTypePropsBase,
  StyledCustomQuestionType,
} from './utils';
import { CustomQuestionAnswerStructure } from 'admin/pages/ManageAccounts/CustomQuestions/utilts';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { faPen } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface CustomQuestionShowProps {
  disableEdit: boolean | undefined;
  answer: CustomQuestionAnswerStructure;
  question: ReportCustomQuestionTypePropsBase['question'];
  handleEdit: () => unknown;
}

const StyledDiv = styled(StyledCustomQuestionType)`
  display: flex;
  gap: ${SPACERS.small};
  align-items: flex-start;
  background-color: ${COLORS.grayLightest};
  .content {
    flex: 1;
    min-width: 0;
    .answer-text {
      margin-top: ${SPACERS.tiny};
      color: ${COLORS.grayDarkest};
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
  .edit-button {
    flex-shrink: 0;
  }
`;

const getAnswerString = (
  answer: CustomQuestionAnswerStructure,
): string | undefined => {
  switch (answer.questionType) {
    case 'text':
    case 'integer':
    case 'comment':
      return answer.answer;
    case 'radio-group':
      return answer.answer.label;
    case 'multi-text':
    case 'multi-integer':
      return answer.answer.map(x => x.placeholder).join(', ');
    case 'checkbox':
    case 'dropdown':
      return answer.answer.map(x => x.label).join(', ');

    default:
      return undefined;
  }
};

const CustomQuestionShow: React.FC<CustomQuestionShowProps> = ({
  answer,
  question,
  handleEdit,
  disableEdit,
}) => {
  const answerString = getAnswerString(answer);
  if (answerString === undefined) {
    return (
      <StyledDiv>
        <TrueImpactText color="critical">Not implemented.</TrueImpactText>
      </StyledDiv>
    );
  }
  return (
    <StyledDiv>
      <div className="content">
        <TrueImpactText variant="body-bold" className="question-text">
          <RenderHtml text={question.questionText} />
        </TrueImpactText>
        <TrueImpactText className="answer-text">{answerString}</TrueImpactText>
      </div>
      <TrueImpactIconButton
        className="edit-button"
        disabled={disableEdit}
        onClick={handleEdit}
        icon={faPen}
        label="Edit"
      />
    </StyledDiv>
  );
};

export default CustomQuestionShow;
